import { makeStyles } from '@material-ui/core/styles'

export const mapView3dStyle = makeStyles((theme) => ({
  root: {
    display: 'flex',
    background: 'grey'
  },
  appBar: {
    zIndex: 0,
    background: theme.palette.geoColors.contextBar.main,
    top: 'auto',
    bottom: 0
  }
}))
